import { EventEmitter, Injectable, Output } from '@angular/core';
declare var $: any;
@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    @Output() notficacao: EventEmitter<any> = new EventEmitter();
    @Output() close: EventEmitter<any> = new EventEmitter();
    status: any;
    constructor() { }
    async notifica(not: Notificacao) {
        await this.notficacao.emit(not);
        setTimeout(() => {
            this.dismiss(not.date);
        }, 15000);
        return {
            dismiss: () => {
                this.dismiss(not.date);
            }
        };
    }
    async loading(not: Notificacao) {
        await this.notficacao.emit(not);
        return {
            dismiss: () => {
                this.dismiss(not.date);
            }
        };
    }
    async dismiss(not: Notificacao) {
        await this.close.emit(not.date);
    }
    setnotifica() {
        return this.notficacao;
    }
    setdismiss() {
        return this.close;
    }
    show(status) {
        this.status = status;
        $('.toast').toast();
    }
    hide() {
        //$('.loading').fadeOut();
    }
}

export interface Notificacao {
    title: string;
    type: string;
    date: any;
    message?: any;
}
